import { CATEGORIES } from "./categories";


function CategoryFilter({ setCurrentCategory }) {
    const categories = CATEGORIES
    return (
        <>
            <p>CategoryFilter</p>
            <aside>
              <ul>
                <li>
                    <button className="btn btn-category btn-mixed-colors"
                            onClick={()=>setCurrentCategory("all")}
                    >
                        All
                    </button>
                </li>
                {
                categories.map((category)=>( 
                    <li key={category.name}>
                        <button className="btn btn-category" id={"btn-" + category.name}
                                onClick={()=>setCurrentCategory(category.name)}
                        >
                            {category.name}
                        </button>
                    </li>
                ))
                }

                {/* <li><button className="btn btn-category btn-mixed-colors">All</button></li>
                <li><button className="btn btn-category" id="btn-technology">technology</button></li>
                <li><button className="btn btn-category" id="btn-science">science</button></li>
                <li><button className="btn btn-category" id="btn-finance">finance</button></li>
                <li><button className="btn btn-category" id="btn-society">society</button></li>
                <li><button className="btn btn-category" id="btn-entertainment">entertainment</button></li>
                <li><button className="btn btn-category" id="btn-health">health</button></li>
                <li><button className="btn btn-category" id="btn-history">history</button></li>
                <li><button className="btn btn-category" id="btn-news">news</button></li> */}
              </ul>
            </aside>
        </>
    );
}
  
export default CategoryFilter;

